var _circle, _path, _path2, _path3, _path4, _path5, _circle2, _circle3, _circle4, _circle5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShowerHeadTub({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 100,
    height: 100,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 49.1,
    cy: 52,
    r: 4.7,
    fill: "#FFF",
    stroke: "#5E6368",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#5E6368",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M49.1 54.1c-1.4 0-3.6.8-5.3 1.3-.3.1-.4-.2-.2-.4 4.3-3.9 4.3-4.3 5.3-9.1.1-.3.4-.3.5 0 1.1 4.8 1.1 5.3 5.3 9.1.2.2 0 .5-.2.4-1.8-.5-4-1.3-5.4-1.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#74AA4E",
    strokeDasharray: "1.137 1.894",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "M49 76.8v9m-2.3-10.3v10.1m4.6-10.1v10.1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#5E6368",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M53.9 19.4c0-.5-.1-.5-.6-.7-2.8-1.1-2.6-3.6-4.3-3.6s-1.5 2.5-4.3 3.6c-.4.2-.6.2-.6.7h9.8z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#5E6368",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M52.6 73c-.4-.9-.6-1.8-.8-2.7-.1-.9-.7-1.9-2.8-1.9-2.1 0-2.7 1-2.8 1.9-.1.9-.3 1.9-.8 2.7l-.2.4h7.4c.1 0 .1-.2 0-.4z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#74AA4E",
    strokeDasharray: "1.137 1.894",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    d: "M45.5 22.5V37m4.7-14.5V39m-2.3-17.8v16.1m4.6-16.1v16.1"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 47.9,
    cy: 19.7,
    r: 0.6,
    fill: "#5E6368"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 50.2,
    cy: 19.7,
    r: 0.6,
    fill: "#5E6368"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 52.5,
    cy: 19.7,
    r: 0.6,
    fill: "#5E6368"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 45.5,
    cy: 19.7,
    r: 0.6,
    fill: "#5E6368"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#5E6368",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M48.3 66.4h1.4m-.7 0v.9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#5E6368",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M42.6 77.1h-5.5c-3.8 0-8 1.7-11.4 4.7l-4.2 3.7m33.9-8.4h5.5c3.8 0 8 1.7 11.4 4.7l4.2 3.7m-53-75h51.1m-25.7 4.6v-2.9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowerHeadTub);
export default __webpack_public_path__ + "static/media/shower-head-tub.b2f519fde38db3379e5ae009b29cc591.svg";
export { ForwardRef as ReactComponent };